export const REMOVE_ADDRESS_ERROR = 'user-address/REMOVE_ADDRESS_ERROR';
export const SET_ADDRESS_ERROR = 'user-address/SET_ADDRESS_ERROR';

